// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-candidate-wrap {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 0px 20px;
}

.pricing-candidate {
    background-color: #1c1b29;
    border: 1px solid #8f32ff;
    padding: 20px;
    color: white;
    text-align: center;
    margin: 10px;
    width: 400px;
}

.pricing-candidate a {
    color: black !important;
    text-decoration: none;
}

.pricing-candidate a:hover {
    color: black !important;
    text-decoration: none;
}

.header-card {
    justify-content: space-between;
    display: flex;
    align-items: center;
}

.candidate-icon {
    width: 50px;
    height: 50px;
}

.payment-type {
    background-color: #9256E8;
    color: white;
    padding: 5px 10px;
    border-radius: 20px;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
}

.candidate-title {
    font-size: 28px;
    font-weight: 600;
    line-height: 42.84px;
    padding: 8px 0px 3px;
    text-align: left;
    font-family: 'SFProDisplay', sans-serif;
}

.candidate-subtitle {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 13px;
    text-align: left;
    font-family: 'SFProDisplay', sans-serif;
}

.candidate-price {
    font-size: 32px;
    font-weight: 800;
    line-height: 38.4px;
    text-align: left;
    font-family: 'SFProDisplay', sans-serif;
}

.candidate-description {
    font-size: 14px;
    line-height: 28px;
    font-weight: 400;
    padding-top: 41px;
    text-align: left;
    min-height: 360px;
}

.candidate-from {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    font-family: 'SFProDisplay', sans-serif;
}

.content-wrap {
    min-height: 220px;
}

.candidate-button {
    background-color: #06EFC5;
    color: #242424;
    border: none;
    padding: 18px 20px;
    font-size: 18.33px;
    line-height: 13.33px;
    cursor: pointer;
    font-weight: 800;
    width: 100%;


}

.candidate-button .arrow {
    margin-left: 5px;
}

@media (max-width: 768px) {
    .pricing-candidate-wrap {
        flex-direction: column;
        padding: 0px;
    }

    .payment-type {
        margin-bottom: 50px;
    }

    .header-card {
        flex-direction: column-reverse;
        align-items: flex-start;
    }

    .candidate-title {
        font-size: 25px;
    }

    .candidate-subtitle {
        font-size: 15px;
    }

    .candidate-price {
        font-size: 20px;
    }

    .candidate-description {
        font-size: 15px;
    }

    .pricing-candidate {
        width: unset;
    }

    .candidate-description {
        min-height: max-content;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PricingCardCandidate/PricingCardCadidate.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;;;AAGf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".pricing-candidate-wrap {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    padding: 0px 20px;\n}\n\n.pricing-candidate {\n    background-color: #1c1b29;\n    border: 1px solid #8f32ff;\n    padding: 20px;\n    color: white;\n    text-align: center;\n    margin: 10px;\n    width: 400px;\n}\n\n.pricing-candidate a {\n    color: black !important;\n    text-decoration: none;\n}\n\n.pricing-candidate a:hover {\n    color: black !important;\n    text-decoration: none;\n}\n\n.header-card {\n    justify-content: space-between;\n    display: flex;\n    align-items: center;\n}\n\n.candidate-icon {\n    width: 50px;\n    height: 50px;\n}\n\n.payment-type {\n    background-color: #9256E8;\n    color: white;\n    padding: 5px 10px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n}\n\n.candidate-title {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 42.84px;\n    padding: 8px 0px 3px;\n    text-align: left;\n    font-family: 'SFProDisplay', sans-serif;\n}\n\n.candidate-subtitle {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    margin-bottom: 13px;\n    text-align: left;\n    font-family: 'SFProDisplay', sans-serif;\n}\n\n.candidate-price {\n    font-size: 32px;\n    font-weight: 800;\n    line-height: 38.4px;\n    text-align: left;\n    font-family: 'SFProDisplay', sans-serif;\n}\n\n.candidate-description {\n    font-size: 14px;\n    line-height: 28px;\n    font-weight: 400;\n    padding-top: 41px;\n    text-align: left;\n    min-height: 360px;\n}\n\n.candidate-from {\n    text-align: left;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    font-family: 'SFProDisplay', sans-serif;\n}\n\n.content-wrap {\n    min-height: 220px;\n}\n\n.candidate-button {\n    background-color: #06EFC5;\n    color: #242424;\n    border: none;\n    padding: 18px 20px;\n    font-size: 18.33px;\n    line-height: 13.33px;\n    cursor: pointer;\n    font-weight: 800;\n    width: 100%;\n\n\n}\n\n.candidate-button .arrow {\n    margin-left: 5px;\n}\n\n@media (max-width: 768px) {\n    .pricing-candidate-wrap {\n        flex-direction: column;\n        padding: 0px;\n    }\n\n    .payment-type {\n        margin-bottom: 50px;\n    }\n\n    .header-card {\n        flex-direction: column-reverse;\n        align-items: flex-start;\n    }\n\n    .candidate-title {\n        font-size: 25px;\n    }\n\n    .candidate-subtitle {\n        font-size: 15px;\n    }\n\n    .candidate-price {\n        font-size: 20px;\n    }\n\n    .candidate-description {\n        font-size: 15px;\n    }\n\n    .pricing-candidate {\n        width: unset;\n    }\n\n    .candidate-description {\n        min-height: max-content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
